<template>
  <div id="dashboard-analytics">
    <h4 class="mb-8">Dashboard - Admin</h4>
    <div class="vx-row">
      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
                    <!--
					<img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="200" >
                    <img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="175">
					-->
          <feather-icon icon="UserIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
          <h1 class="mb-6 text-white">Welcome {{ user.firstName }},</h1>
          <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">Have a nice day :-)</p>
        </vx-card>
      </div>

      <!-- CARD 2: USERS REGISTERED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="UsersIcon" statistic="3.142" statisticTitle="Registered Users" :chartData="usersRegistered.series" type="area"></statistics-card-line>
      </div>

      <!-- CARD 3: USER SESSIONS -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="ActivityIcon" statistic="97.5K" statisticTitle="User Sessions" :chartData="userSessions.series" color="primary" type="area"></statistics-card-line>
      </div>
    </div>

    <div class="vx-row">

      <!-- CARD 4: NEW ARTICLES -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <statistics-card-line icon="BookmarkIcon" statistic="4 today" statisticTitle="New Articles" :chartData="usersRegistered.series" color="success" type="area"></statistics-card-line>
      </div>

      <!-- CARD 5: NEW POSTS -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <statistics-card-line icon="Edit3Icon" statistic="27 today" statisticTitle="New Posts" :chartData="userSessions.series" color="warning" type="area"></statistics-card-line>
      </div>
    </div>

        <div class="vx-row">
            <!-- CARD 6: Product Orders -->
            <div class="vx-col w-full lg:w-1/3 mb-base">
                <vx-card title="Venue Training Sessions">
                    <!-- CARD ACTION -->
                    <template slot="actions">
                        <change-time-duration-dropdown />
                    </template>

                    <!-- Chart -->
                    <div slot="no-body">
                        <vue-apex-charts type="radialBar" height="420" :options="analyticsData.productOrdersRadialBar.chartOptions" :series="productsOrder.series" />
                    </div>

                    <ul>
                        <li v-for="orderData in productsOrder.analyticsData" :key="orderData.orderType" class="flex mb-3 justify-between">
                            <span class="flex items-center">
                                    <span class="inline-block h-4 w-4 rounded-full mr-2 bg-white border-3 border-solid" :class="`border-${orderData.color}`"></span>
                                    <span class="font-semibold">{{ orderData.orderType }}</span>
                            </span>
                            <span>{{ orderData.counts }}</span>
                        </li>
                    </ul>
                </vx-card>
            </div>

            <!-- CARD 7: Learning Stats -->
            <div class="vx-col w-full lg:w-1/3 mb-base">
              <vx-card title="Online Training Assessment" subtitle="Last Month">
                <template slot="actions">
                  <feather-icon icon="MoreVerticalIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                </template>
                <div class="flex">
                  <span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>Score</span></span>
                  <!--<span class="flex items-center ml-4"><div class="h-3 w-3 rounded-full mr-1 bg-success"></div><span>Visits</span></span>-->
                </div>
                <div slot="no-body-bottom">
                  <vue-apex-charts type="radar" height="430" :options="learningRadarOptions.chartOptions" :series="learningRadar.series" />
                </div>
              </vx-card>
            </div>

            <!-- CARD 8: Activity Timeline -->
            <div class="vx-col w-full lg:w-1/3 mb-base">
                <vx-card title="Upcoming Events">
                    <vx-timeline :data="upcomingEvents" />
                </vx-card>
            </div>
        </div>

<!--
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="Dispatched Orders">
          <div slot="no-body" class="mt-4">
            <vs-table :data="dispatchedOrders" class="table-dark-inverted">
              <template slot="thead">
                <vs-th>ORDER NO.</vs-th>
                <vs-th>STATUS</vs-th>
                <vs-th>OPERATORS</vs-th>
                <vs-th>LOCATION</vs-th>
                <vs-th>DISTANCE</vs-th>
                <vs-th>START DATE</vs-th>
                <vs-th>EST DELIVERY DATE</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].orderNo">
                    <span>#{{data[indextr].orderNo}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].status">
                    <span class="flex items-center px-2 py-1 rounded"><div class="h-3 w-3 rounded-full mr-2" :class="'bg-' + data[indextr].statusColor"></div>{{data[indextr].status}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <ul class="users-liked user-list">
                        <li v-for="(user, userIndex) in data[indextr].usersLiked" :key="userIndex">
                            <vx-tooltip :text="user.name" position="bottom">
                                <vs-avatar :src="user.img" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                            </vx-tooltip>
                        </li>
                    </ul>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <span>{{data[indextr].location}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <span>{{data[indextr].distance}}</span>
                    <vs-progress :percent="data[indextr].distPercent" :color="data[indextr].statusColor"></vs-progress>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <span>{{data[indextr].startDate}}</span>
                  </vs-td>
                  <vs-td :data="data[indextr].orderNo">
                    <span>{{data[indextr].estDelDate}}</span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>

        </vx-card>
      </div>
    </div>
-->
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from '@/views/ui-elements/card/analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import VxTimeline from '@/components/timeline/VxTimeline'

export default {
  data () {
    return {
      checkpointReward: {},
      usersRegistered: {},
      userSessions: {},
      salesBarSession: {},
      supportTracker: {},
      productsOrder: {},
      learningRadar: {},
      learningRadarOptions: {
    
    chartOptions: {
      labels: ['Cocktails', 'Customers', 'Interior', 'Daily Operations', 'Management', 'Food'],
      dataLabels: {
        style: {
          colors: ['#b9c3cd', '#b9c3cd', '#b9c3cd', '#b9c3cd', '#b9c3cd', '#b9c3cd']
        }
      },
      yaxis: {
        show: false
      },
      grid: {
        show: false
      },
      legend: { show: false },
      chart: {
        dropShadow: {
          enabled: true,
          blur: 8,
          left: 1,
          top: 1,
          opacity: 0.2
        },
        toolbar: {
          show: false
        }
      },
      stroke: {
        width: 0
      },
      colors: ['#9f8ed7', '#1edec5'],
      plotOptions: {
        radar: {
          polygons: {
            strokeColors: ['#e8e8e8', 'transparent', 'transparent', 'transparent', 'transparent', 'transparent'],
            connectorColors: 'transparent'
          }
        }
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          gradientToColors: ['#8e9ad6', '#1fcadb'],
          shadeIntensity: 1,
          type: 'horizontal',
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100, 100, 100]
        }
      },
      markers: {
        size: 0
      }
    }
  },

      upcomingEvents: [
        {
          color: 'success',
          icon: 'UsersIcon',
          title: 'Board Meeting',
          desc: 'Talk about the new salary model.',
          time: 'Fri. 04-09-2020 14:30'
        },
        {
          color: 'primary',
          icon: 'LayoutIcon',
          title: 'OnlineTraining XYZ',
          desc: 'Introduction on how to handle conflicts.',
          time: 'Mon. 07-09-2020 11:15'
        }
      ],


      analyticsData,
      dispatchedOrders: []
    }
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline
  },
  computed: {
    user() {
      let user = null;
      if (this.$AuthService.isAuthenticated()) { // Note that the dollar sign ($) is missing from this.msal
        user = {
          ...this.$AuthService.getUser(),
          profile: {}
        }
      }

console.log(user);
      return user;
    }
  },
  created () {

	// Orders - Statistics
	this.userSessions = {
		series: [
		{
			name: 'Users',
			data: [10, 15, 8, 15, 7, 12, 8]
		}
		]
	};
	this.salesBarSession = {
		series: [
		{
			name: 'Sessions',
			data: [75, 125, 225, 175, 125, 75, 25]
		}
		],
		analyticsData: {
		session: 2700,
		comparison : {
			str: 'Last 7 Days',
			result: +5.2
		}
		}
	};

	// Users Registered
	this.usersRegistered = {
		series: [
		{
			name: 'Users',
			data: [28, 40, 36, 52, 38, 60, 55]
		}
		]
	};

	// Products Order
	this.productsOrder = {
		analyticsData: [
		{
			'orderType': 'Completed',
			'counts': 23043,
			'color': 'primary'
		},
		{
			'orderType': 'In-Progress',
			'counts': 4758,
			'color': 'warning'
		},
		{
			'orderType': 'Signed Up ',
			'counts': 14658,
			'color': 'danger'
		}
		],
		series: [70, 52, 26]
	};

	// Support Tracker
	this.supportTracker = {
		analyticsData: {
		openTickets: 163,
		meta: {
			'New Tickets': 29,
			'Open Tickets': 63,
			'Response Time': '1d'
		}
		},
		series: [83]
	};
	// Learning Radar
	this.learningRadar = {
		series: [
      {
        name: 'Score',
        data: [80, 90, 30, 40, 100, 20]
      }
    ]
	};
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
